module.exports = __webpack_public_path__ + "images/menu-spread.d969bb08322e8bd2dd30667dee07023a.png";